define((require) => {
    "use strict";

    const Backbone   = require("backbone"),
        template   = require("ui/editor/email/renderer/EmailMetaData.tpl");

    return Backbone.View.extend({
        template,
        render() {
            this.el = this.template({
                styles: this.options.styles,
                gmailStyles: this.options.gmailStyles
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/renderer/EmailMetaData.js